module.exports = __webpack_public_path__ + "img/Pierre-Emerick Aubameyang.9a5ce6e2.png";